<div class="container mt-5">
  <div class="card shadow-sm mx-auto" style="max-width: 400px">
    <div class="card-body text-center p-4">
      <div class="success-icon mb-3">
        <!-- <i
      class="bi bi-check-circle-fill text-success"
      style="font-size: 3rem"
    ></i> -->
        <fa-icon [icon]="faCheckCircle"
                 class="text-success"
                 style="font-size: 3rem"></fa-icon>
      </div>

      <!--<h2 class="mb-3" [dir]="direction">{{ amount }} {{ currency }}</h2>-->
    <h3 class="mb-3" >{{ "translations.Payment_Process_is_Successfully_Done" | translate }} </h3>


      <div class="text-center mt-4 mb-4">
        <a href="/"> <img [src]="logoUrl" alt="Company Logo" style="max-width: 100px" /> </a>
      </div>

      <!--<button class="btn btn-dark w-100" (click)="downloadPDF()">
    <i class="bi bi-download me-2"></i>{{ labels.downloadPDF }}
  </button>-->
    </div>
  </div>
</div>
